import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAttentionData } from '../../hooks/useDashboardQueries';
import { LedgerSkeleton } from '../shell/LedgerSkeleton';
import { cn } from '../../lib/cn';
import { severityBgClass } from '../../lib/severity';

export const AttentionQueue: React.FC = () => {
  const { items, isPending } = useAttentionData();
  const navigate = useNavigate();

  return (
    <section aria-label="Needs attention">
      <div className="flex justify-between border-b border-ink pb-1">
        <span className="cap-label !text-ink">Needs attention</span>
      </div>
      {isPending ? (
        <LedgerSkeleton lines={4} className="mt-3" />
      ) : items.length === 0 ? (
        <p className="py-4 font-serif text-scale-1 italic text-ink-muted">Nothing needs attention.</p>
      ) : (
        items.map((it) => (
          <button key={`${it.kind}-${it.id}`} type="button"
            onClick={() => navigate(it.kind === 'task' ? '/tasks' : '/risks')}
            className="flex w-full items-baseline gap-2.5 border-b border-rule-faint py-2 text-left text-scale-1 hover:bg-accent-soft">
            <span className="w-16 shrink-0 font-mono text-scale-0 text-ink-muted">{it.ref}</span>
            {it.kind === 'risk' && (
              <span aria-hidden className={cn('h-2 w-2 shrink-0 self-center', it.severityScore != null && severityBgClass(it.severityScore))} />
            )}
            <span className="min-w-0 flex-1 truncate text-ink">
              {it.title}{' '}
              <span className={cn('font-serif italic', it.alert ? 'text-sev-critical' : 'text-ink-muted')}>
                — {it.annotation}
              </span>
            </span>
            <span className="shrink-0 text-scale-0 text-ink-muted">{it.owner}</span>
            <span className={cn('w-14 shrink-0 text-right font-mono text-scale-0', it.alert ? 'text-sev-critical' : 'text-ink-muted')}>
              {it.date ? it.date.slice(5).replace('-', '/') : '—'}
            </span>
          </button>
        ))
      )}
    </section>
  );
};
